import "core-js/modules/es.array.reverse.js";
import "core-js/modules/web.dom-collections.iterator.js";
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
import { computed, makeObservable } from "mobx";
function ExportableMixin(Base) {
  var _class;
  let ExportableMixin = (_class = class ExportableMixin extends Base {
    constructor() {
      super(...arguments);
      makeObservable(this);
    }

    /**
     * Indicates if model is able to export data (will turn on/off UI elements)
     */
    get canExportData() {
      return !this.disableExport && this._canExportData;
    }
    /**
     * @returns an async function which returns a URL (to download) or a Blob with filename
     */
    exportData() {
      if (this.canExportData) {
        return this._exportData();
      }
    }
  }, _applyDecoratedDescriptor(_class.prototype, "canExportData", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "canExportData"), _class.prototype), _class);
  return ExportableMixin;
}
(function (_ExportableMixin) {
  function isMixedInto(model) {
    return model && "exportData" in model && "canExportData" in model;
  }
  _ExportableMixin.isMixedInto = isMixedInto;
})(ExportableMixin || (ExportableMixin = {}));
export default ExportableMixin;